import { render, staticRenderFns } from "./CreateSite.vue?vue&type=template&id=3bcdd757&scoped=true"
import script from "./CreateSite.vue?vue&type=script&lang=js"
export * from "./CreateSite.vue?vue&type=script&lang=js"
import style0 from "./CreateSite.vue?vue&type=style&index=0&id=3bcdd757&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcdd757",
  null
  
)

export default component.exports